import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'

export const fetchSuppliersSelectQuery = gql`
  query SearchOrganizations {
    organization(where: {catalogs: {is_active: { _eq: true}}}, order_by: {name: asc}) {
      id
      tax_id
      name
    }
  }
`
export const fetchBuyersSelectQuery = gql`
  query SearchOrganizations {
    organization(where: { _not: { catalogs: { is_active: { _eq: true}} }}, order_by: {name: asc}) {
      id
      tax_id
      name
    }
  }
`
export const fetchProviderOrganizationsQuery = gql`
   query fetchProviderOrganizationsQuery(
     $name: String,
     $country: String,
     $tax_id: String,
     $limit: Int!,
     $offset: Int!,
     $public_catalog_ids: [Int!] = [1, 4]
   ) {
     organization(
       where: {
         name: { _ilike: $name },
         country: { _eq: $country },
         tax_id: { _eq: $tax_id },
         entity_type: { _eq: 1 },
       },
       limit: $limit,
       offset: $offset,
       order_by: { name: asc }
     ) {
       id
       name
       tax_id
       contact_email
       created_at
       country
       plan_id
       requires_terms_acceptance
       terms_and_conditions_id
       plan_type {
         name
         __typename
       }
       catalogs_aggregate(
         where: {
           catalog_type_id: { _in: $public_catalog_ids }
         }
       ) {
         aggregate {
           count
           __typename
         }
         __typename
       }
       __typename
     }
     organization_aggregate(
       where: {
         name: { _ilike: $name },
         country: { _eq: $country },
         tax_id: { _eq: $tax_id },
         entity_type: { _eq: 1 },
       }
     ) {
       aggregate {
         count
         __typename
       }
       __typename
     }
   }
`

export const fetchBuyerOrganizationsQuery = gql`
query fetchBuyerOrganizationsQuery(
  $name: String,
  $country: String,
  $tax_id: String,
  $limit: Int!,
  $offset: Int!,
  $public_catalog_ids: [Int!] = [1, 4]
) {
  organization(
    where: {
      name: { _ilike: $name },
      country: { _eq: $country },
      tax_id: { _eq: $tax_id },
      entity_type: { _eq: 2 },
    },
    limit: $limit,
    offset: $offset,
    order_by: { name: asc }
  ) {
    id
    name
    tax_id
    contact_email
    created_at
    country
    plan_id
    requires_terms_acceptance
    terms_and_conditions_id
    plan_type {
      name
      __typename
    }
    catalogs_aggregate(where: { catalog_type_id: { _nin: $public_catalog_ids } }) {
      aggregate {
        count
        __typename
      }
      __typename
    }
    __typename
  }
  organization_aggregate(
    where: {
      name: { _ilike: $name },
      country: { _eq: $country },
      tax_id: { _eq: $tax_id },
      entity_type: { _eq: 2 },
    }
  ) {
    aggregate {
      count
      __typename
    }
    __typename
  }
}
`

export const fetchOrganizationByIdQuery = gql`
  query SearchOrganization($organization_id: uuid!) {
    organization(where: {id: {_eq: $organization_id}}) {
      id
      name
      tax_id
      contact_name
      contact_email
      description
      last_billing
      country
      city
      address
      plan_id
      website
      requires_terms_acceptance
      client_type
      legal_name
      contact_phone
      newProvider
      terms_and_conditions_id
      is_blocked_by_contract
      contracted_value
      contract_start_date
      contract_end_date
      notify
      total_items
      total_items_active
      membership_status_id
      membership_id
      membership_suggested_id
      last_invoice_date
      observations
      observations_status
      catalogs_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`
export const createOrganizationMutation = gql`
  mutation CreateOrganization($data: [organization_insert_input!]!) {
    insert_organization(objects: $data) {
      affected_rows
      returning {
        id
      }
    }
  }
`
export const updateOrganizationMutation = gql`
  mutation UpdateOrganization($organizationId: uuid!, $data: organization_set_input!) {
    update_organization(where: {id: {_eq: $organizationId}}, _set: $data) {
      affected_rows
      returning {
        id
        name
        tax_id
        contact_name
        contact_email
        description
        last_billing
        country
        city
        address
        plan_id
        website
      }
    }
  }
`
export const fetchOrganizationByTaxIdQuery = gql`
  query SearchOrganizationByTax($tax_id: String!) {
    organization(where: {tax_id: {_eq: $tax_id}}) {
      id
    }
  }
`

export const fetchAvailableCountries = gql`
query SearchAvailableCountries {
  country(where: {show: {_eq: true}}) {
    code
  }
}
`

export const fetchOrganizationsCountries = gql`
query SearchOrganizationsCountries {
  organization(distinct_on: country, where: {country: {_is_null: false}}) {
    code: country
  }
}
`
export const getAcceptedTermsConditions = gql`
query getAcceptedTermsConditions($organizationID: uuid!) {
  organization_accepted_terms(where: {organization_id: {_eq: $organizationID}}, order_by: {acceptance_date: desc}) {
    acceptance_date
    user {
      email
      first_name
    }
    id
    terms_and_conditions_version
  }
}
`

export const fetchMembershipStatus = gql`
  query fetchMembershipStatus {
    membership_status {
      id
      description
    }
  }
`

export const fetchMembership = gql`
  query fetchMembership {
    membership {
      id
      range
      amount_awarded_previous_year_usd
      membership_actual_year_usd
    }
  }
`

const organization = {
  namespaced: true,
  state: {
    tax_id: '',
    name: '',
    organizations: [],
    organizations_count: 0,
    buyers: [],
    suppliers: [],
    acceptedTermsAndConditions: [],
    organization: {},
    membershipStatus: [],
    membership: []
  },
  actions: {
    init ({ state }, data) {
      if (data) {
        if (data.tax_id) {
          Vue.set(state, 'tax_id', data.tax_id)
        }
        if (data.name) {
          Vue.set(state, 'name', data.name)
        }
      } else {
        try {
          Vue.set(state, 'organizations', [])
          Vue.set(state, 'organization', {})
          Vue.set(state, 'tax_id', '')
          Vue.set(state, 'name', '')
        } catch (error) {
          throw new Error(error)
        }
      }
    },
    async getBuyers ({ commit }) {
      try {
        let requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchBuyersSelectQuery
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_BUYERS', result.data.organization)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async getSuppliers ({ commit }) {
      try {
        let requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchSuppliersSelectQuery
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_SUPPLIERS', result.data.organization)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async fetchAll ({ commit }, { targetSupplierOrg, ...variables }) {
      try {
        let requestQuery = {
          fetchPolicy: 'network-only',
          query: targetSupplierOrg ? fetchProviderOrganizationsQuery : fetchBuyerOrganizationsQuery,
          variables
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_ORGANIZATIONS', result.data.organization)
          commit('SET_ORGANIZATIONS_COUNT', result.data.organization_aggregate.aggregate.count)
          if (variables.tax_id) {
            commit('SET_TAXID', variables.tax_id)
          }
          if (variables.name) {
            commit('SET_NAME', variables.name)
          }
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async fetchOrganizationsCountries ({commit}) {
      try {
        let requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchOrganizationsCountries
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          const countryCodes = result.data.organization.map(item => item.code)
          commit('SET_ORGANIZATIONS_COUNTRIES', countryCodes)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async fetchAvailableCountries ({commit}) {
      try {
        let requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchAvailableCountries
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          const countryCodes = result.data.country.map(item => item.code)
          commit('SET_AVAILABLE_COUNTRIES', countryCodes)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async get ({ commit }, organizationId) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchOrganizationByIdQuery,
          variables: {
            organization_id: organizationId
          }
        }

        const response = await apolloClient.query(requestQuery)
        if (response && response.data) {
          commit('SET_ORGANIZATION', response.data.organization[0])
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async create ({ commit }, data) {
      try {
        const insertMutation = {
          mutation: createOrganizationMutation,
          variables: { data }
        }

        const result = await apolloClient.mutate(insertMutation)
        if (result && result.data) {
          commit('SET_ORGANIZATION', result.data.insert_organization.returning[0])
        }

        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    },
    async update ({ commit }, organization) {
      try {
        const updateMutation = {
          mutation: updateOrganizationMutation,
          variables: {
            organizationId: organization.id,
            data: {
              name: organization.name,
              tax_id: organization.tax_id,
              contact_name: organization.contact_name,
              contact_email: organization.contact_email,
              description: organization.description,
              last_billing: organization.last_billing,
              country: organization.country,
              city: organization.city,
              address: organization.address,
              plan_id: organization.plan_id,
              terms_and_conditions_id: organization.terms_and_conditions_id,
              requires_terms_acceptance: organization.requires_terms_acceptance,
              client_type: organization.client_type,
              website: organization.website,
              legal_name: organization.legal_name,
              contact_phone: organization.contact_phone,
              newProvider: organization.newProvider
            }
          }
        }
        const result = await apolloClient.mutate(updateMutation)
        if (result && result.data) {
          commit('SET_ORGANIZATION', result.data.update_organization.returning[0])
        }

        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateOrg ({ commit }, {organizationId, organizationData}) {
      try {
        const updateMutation = {
          mutation: updateOrganizationMutation,
          variables: {
            organizationId: organizationId,
            data: organizationData
          }
        }
        const result = await apolloClient.mutate(updateMutation)
        if (result && result.data) {
          commit('SET_ORGANIZATION', result.data.update_organization.returning[0])
        }

        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async getAcceptedTerms ({ state }, variables) {
      try {
        let requestQuery = {
          query: getAcceptedTermsConditions,
          variables
        }
        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          Vue.set(state, 'acceptedTerms', result.data.organization_accepted_terms)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async searchIdOrganizationByTax ({ commit }, taxId) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchOrganizationByTaxIdQuery,
          variables: {
            tax_id: taxId
          }
        }
        const response = await apolloClient.query(requestQuery)
        if (response && response.data && response.data.organization.length) {
          return response.data.organization[0].id
        } else {
          return null
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async getMembershipStatus ({ commit }) {
      try {
        let requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchMembershipStatus
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_MEMBERSHIP_STATUS', result.data.membership_status)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async getMembership ({ commit }) {
      try {
        let requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchMembership
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_MEMBERSHIP', result.data.membership)
        }
      } catch (err) {
        window.console.error(err)
      }
    }
  },
  mutations: {
    SET_ORGANIZATIONS (state, data) {
      Vue.set(state, 'organizations', data)
    },
    SET_ORGANIZATIONS_COUNT (state, data) {
      Vue.set(state, 'organizations_count', data)
    },
    SET_BUYERS (state, data) {
      Vue.set(state, 'buyers', data)
    },
    SET_SUPPLIERS (state, data) {
      Vue.set(state, 'suppliers', data)
    },
    SET_ORGANIZATION (state, data) {
      Vue.set(state, 'organization', data)
    },
    SET_TAXID (state, data) {
      Vue.set(state, 'tax_id', data)
    },
    SET_NAME (state, data) {
      Vue.set(state, 'name', data)
    },
    SET_ORGANIZATIONS_COUNTRIES (state, data) {
      Vue.set(state, 'organizations_countries', data)
    },
    SET_AVAILABLE_COUNTRIES (state, data) {
      Vue.set(state, 'available_countries', data)
    },
    SET_MEMBERSHIP_STATUS (state, data) {
      Vue.set(state, 'membershipStatus', data)
    },
    SET_MEMBERSHIP (state, data) {
      Vue.set(state, 'membership', data)
    }
  },
  getters: {
    organizationsInfo: state => state.organizations,
    organizationsCountInfo: state => state.organizations_count,
    buyersInfo: state => state.buyers,
    suppliersInfo: state => state.suppliers,
    organizationInfo: state => state.organization,
    taxIdInfo: state => state.tax_id,
    nameInfo: state => state.name,
    organizationsCountries: state => state.organizations_countries,
    availableCountries: state => state.available_countries,
    membershipStatus: state => state.membershipStatus,
    membership: state => state.membership
  }
}

export default organization



// WEBPACK FOOTER //
// ./src/store/modules/organization.js